import Backbone from 'backbone';
import DropdonItem from './DropdownItem';
import States from '../model/States';
import config from '../config/config';

export default Backbone.View.extend({
  initialize(o) {
    this.collection = o.collection;
    this.em = o.em;
    this.GConfig = o.GConfig;
    this.on('stateSelected', this.stateSelected);
    this.on('stateDeleted', this.stateDeleted);
  },

  events: {
    'click .state_dropdown .value': 'dropdownClicked',
    'click .state_dropdown .btn': 'resetState',
    'click .state_dropdown .dd-add-state': 'addState'
  },

  template() {
    return `<div class="input-btn-wrp dd">
              <div class="dd-wrp">
                <div class="value">Please select state..</div>
                  <i class="fa fa-caret-down"></i>
                  <div class="state_menu hide">
                </div>
              </div>
              <div class="dd-add-state right-btn"> 
                <img src="${this.GConfig.rootDir}/assets/icons/plus.svg">
              </div>
            </div>
            <div class="add_state input-btn-wrp hide">
              <div class="input-wrp"><input type="text" placeholder="State name"></div>
              <div class="right-btn"><img src="${this.GConfig.rootDir}/assets/icons/tick.svg"></div>
            </div>
            <div class="btn green hide">Save</div>`;
  },

  stateDeleted(model) {
    var sel = this.em.getSelected();
    var cssc = this.em.CssComposer;
    var className = model.get('className');
    this.collection.remove(model);
    cssc.getAll().remove(cssc.getRule('.' + className + '#' + sel.getId()));
    sel.set('statesCollection', this.collection.toJSON());
  },

  stateSelected(model) {
    this.$el.find('.value').text(model.get('name'));
    this.$el.find('.state_menu').addClass('hide');
    model.get('className')
      ? this.$el.find('.btn.green').removeClass('hide')
      : this.$el.find('.btn.green').addClass('hide');
  },

  resetState() {
    this.$el
      .find('.state_menu .item-wrapper:first-child .item')
      .trigger('click');
    this.$el.find('.btn.green').addClass('hide');
  },

  dropdownClicked(e) {
    this.$el.find('.state_menu').toggleClass('hide');
  },

  addState() {
    this.$el.find('.input-btn-wrp.dd').addClass('hide');
    this.$el.find('.add_state').removeClass('hide');
  },

  addToCollection(model, fragmentEl) {
    var fragment = fragmentEl || null;
    var viewObject = DropdonItem;
    var view = new viewObject({
      model,
      parent: this,
      em: this.em
    });
    var rendered = view.render().el;

    if (fragment) {
      fragment.appendChild(rendered);
    } else {
      this.$el.find('.state_menu').append(rendered);
    }
    return rendered;
  },

  render() {
    var fragment = document.createDocumentFragment();
    this.$el.empty();
    this.collection.each(function(model) {
      this.addToCollection(model, fragment);
    }, this);
    this.$el.addClass('state_dropdown');
    this.$el.append(this.template());
    this.$el.find('.state_menu').append(fragment);
    this.resetState();
    return this;
  }
});
